import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { MDCMenuSurface, MDCMenuSurfaceFoundation } from '@material/menu-surface';
import 'next/stylesheets/components/projects/todo-advance-filter';

Component('tr-project-todo-advance-filter', {
  mixins: [eventListenerMixin],

  properties: {
    conjunction: {
      type: String,
      observer: 'conjunctionChanged',
    },
  },

  connected() {
    this.menu = new MDCMenuSurface(this.querySelector('.mdc-menu-surface'));
    this.menu.quickOpen = true;

    this.listenTo(this, 'tr-project-todo-advance-filter:fieldChange', () => {
      this.updateFormFieldReadonly();
      this.repaintFormFields();
    });

    this.listenTo(this.menu, {
      'MDCMenuSurface:opened': this.handleMenuSurfaceOpened.bind(this),
      'tr-combo-select-field:change': (event) => {
        if (closest(event.target, '.projects_filter_conditions_key')) {
          this.handleKeySelected(event);
        } else if (closest(event.target, '.projects_filter_conditions_predicate')) {
          this.handlePredicateSelected(event);
        } else if (closest(event.target, '.projects_filter_conditions_conjunction')) {
          this.conjunction = event.detail;
        }
      },
    });

    $(this).on('cocoon:after-insert', (event, items) => {
      items.find('.projects_filter_conditions_conjunction tr-combo-select-field')
        .get().forEach((item) => {
          this.listenTo(item, 'tao:ready', () => this.conjunctionChanged(this.conjunction));
        });
    });

    $(this)
      .on('cocoon:after-insert', () => { setTimeout(() => this.namespacedTrigger('fieldChange'), 0); })
      .on('cocoon:after-remove', (_, $el) => {
        $el.remove();
        setTimeout(() => this.namespacedTrigger('fieldChange'), 0);
      });
  },

  ready() {
    const conjunctionSelector = this.querySelector('.projects_filter_conditions_conjunction tr-combo-select-field');
    if (conjunctionSelector) conjunctionSelector.notifyChange();

    this.querySelectorAll('.projects_filter_conditions_predicate tr-combo-select-field').forEach((f) => {
      f.notifyChange();
    });

    // eslint-disable-next-line no-underscore-dangle
    this.menu
      .foundation_.handleBodyClick = function handleBodyClick(event) {
        if (!closest(event.target, 'body > .wrapper')) return;
        MDCMenuSurfaceFoundation.prototype.handleBodyClick.call(this, event);
      };
  },

  handleMenuSurfaceOpened() {
    if (!this.querySelector('.nested-fields')) {
      this.querySelector('.link-add-filter').click();
    } else {
      this.namespacedTrigger('fieldChange');
    }
  },

  handleKeySelected({ target, detail }) {
    const template = this.querySelector(`#tpl-todo-filter-${detail.toString().replace('.', '__')}`);
    const newCondition = document.importNode(template.content, true).firstElementChild;
    const currentCondition = closest(target, '.nested-fields', this);

    const index = currentCondition.querySelector('.projects_filter_conditions_key select')
      .name.match(/\[conditions_attributes\]\[(\d+)\]/)[1];

    [...newCondition.querySelectorAll('input, select')].forEach((_el) => {
      const el = _el;
      el.name = el.name.replace(/\[conditions_attributes\]\[(\d+)\]/, `[conditions_attributes][${index}]`);
    });

    newCondition.querySelector('.projects_filter_conditions_conjunction tr-combo-select-field')
      .addEventListener('tao:ready', () => {
        this.conjunctionChanged(this.conjunction);
      }, { once: true });

    setTimeout(() => {
      currentCondition.replaceWith(newCondition);

      setTimeout(() => {
        this.namespacedTrigger('fieldChange');
      }, 0);
    }, 0);
  },

  handlePredicateSelected({ target, detail }) {
    const container = closest(target, '.nested-fields');
    if (!container) return;

    const valueField = container.querySelector('.projects_filter_conditions_form_value');
    if (!valueField) return;

    const visible = ['be_nil', 'not_be_nil'].indexOf(detail) === -1;
    valueField.classList.toggle('hidden', !visible);
  },

  updateFormFieldReadonly() {
    const conditions = this.querySelectorAll('.nested-fields');
    const firstCondition = conditions[0];
    const firstConditionKey = firstCondition.querySelector('.projects_filter_conditions_key tr-combo-select-field');
    const firstConditionPredicate = firstCondition.querySelector('.projects_filter_conditions_predicate tr-combo-select-field');

    if (firstConditionKey && firstConditionKey.getValue() === 'completion_status') {
      firstConditionKey.setAttribute('readonly', true);
      firstConditionPredicate.setAttribute('readonly', true);
    }

    [...this.querySelectorAll('.projects_filter_conditions_conjunction tr-combo-select-field')].forEach((el, index) => {
      el.toggleAttribute('readonly', index !== 1);
    });
  },

  conjunctionChanged(conjunction) {
    this.querySelectorAll('.projects_filter_conditions_conjunction tr-combo-select-field')
      .forEach(selector => selector.setValue(conjunction));
  },

  repaintFormFields() {
    this.querySelectorAll('.mdc-notched-outline__trailing').forEach((el) => {
      const { style } = el;
      const { display } = style;

      style.display = 'none';
      // eslint-disable-next-line no-unused-vars
      const trick = el.offsetHeight;
      style.display = display;
    });
  },

  disconnected() {
    this.stopListening();
  },
});
